<script>
// CommitChart.js
import { Radar } from "vue-chartjs";

export default {
  extends: Radar,
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [
            "Prozesstreue",
            "Standardkonformität",
            "Gelebtes QM",
            "Ordentliches QM",
            "Glauben an Fortschritt"
          ],
          datasets: [
            {
              label: "Audit Visualisierung",
              borderColor: "#b2ebf2",
              data: [9, 7, 8, 1, 4]
            }
          ]
        };
      }
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {
          scale: {
            ticks: {
              beginAtZero: true,
              max: 100
            }
          }
        };
      }
    }
  },
  watch: {
    chartOptions() {
      this.render();
    },
    chartData() {
      this.render();
    }
  },
  mounted() {
    // Overwriting base render method with actual data.

    this.render();
  },
  methods: {
    render() {
      this.renderChart(this.chartData, this.chartOptions);
    }
  }
};
</script>
